module.exports = __webpack_public_path__ + "static/media/eh-logo.bdf1ee97.png";